import React from 'react';
import cx from 'classnames';
import { Icon } from 'js/components';

import { faRight } from '@fortawesome/pro-solid-svg-icons';
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons';

import styles from './AssessUserGroup.module.scss';

function SourceCard({
  className,
  title,
  superscript,
  children,
  onClick = () => {},
  isLoading = false,
}) {
  const cardClass = cx('btn btn-primary', styles['source-card'], className);

  return (
    <button className={cardClass} onClick={onClick} disabled={isLoading}>
      <span className={styles['source-content']}>
        <span className={styles['source-title']}>
          {title}
          {superscript ? (
            <sup className={styles['source-superscript']}>{superscript}</sup>
          ) : null}
        </span>
        <span className={styles['source-body']}>{children}</span>
      </span>
      <span className={styles['source-button']}>
        Start from this
        {isLoading ? (
          <Icon icon={faCircleNotch} spin className="icon-right" fixedWidth />
        ) : (
          <Icon icon={faRight} className="icon-right" fixedWidth />
        )}
      </span>
    </button>
  );
}

export default SourceCard;
